import { useEffect, useRef } from 'react';

/**
 * Adds `is-visible` class to element when it scrolls into view.
 * Usage: const ref = useReveal(); <div ref={ref} className="reveal">
 */
export const useReveal = (options = { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-visible');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, options);
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
};
